import React from 'react';

import { useTranslation } from 'react-i18next';

import gtmTracker from '@utils/gtmTracker';

import useEnglishTranslation from '@hooks/use-english-translation';

import { config } from '@/config.ts';

import * as Styled from './desktop-nav.styled';
import { getNavListForBrand } from '../../nav-config.ts';

const isBlitz = config.BRAND === 'blitz';

type OwnProps = {
	isAuthenticated?: boolean;
};

const DesktopNav: React.FC<OwnProps> = ({ isAuthenticated }) => {
	const { t } = useTranslation();
	const tEn = useEnglishTranslation();
	const navList = getNavListForBrand(config.BRAND, isAuthenticated);

	const handleMenuClick = (label: string) => {
		gtmTracker.trackEvent('click', {
			event_category: 'Menu',
			event_action: 'click',
			event_label: label
		});
	};

	return (
		<Styled.Wrapper>
			<Styled.NavContainer>
				{navList.map(nav => {
					// Skip if onlyLoggedIn and not authenticated
					if (nav.onlyLoggedIn && !isAuthenticated) return null;

					return (
						<Styled.LinkStyled
							key={nav.key}
							to={nav.path}
							$isBlitz={isBlitz}
							onClick={() => handleMenuClick(tEn(nav.labelKey))}
						>
							{t(nav.labelKey)}
						</Styled.LinkStyled>
					);
				})}
			</Styled.NavContainer>
		</Styled.Wrapper>
	);
};

export default DesktopNav;
